var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5714 1H7.42858C6.51926 1 5.64719 1.36122 5.00421 2.0042C4.36123 2.64719 4.00001 3.51926 4.00001 4.42857V22.7143C3.99921 22.9156 4.05164 23.1137 4.15198 23.2883C4.25233 23.4629 4.39703 23.6079 4.57144 23.7085C4.74517 23.8089 4.94225 23.8617 5.14286 23.8617C5.34348 23.8617 5.54056 23.8089 5.71429 23.7085L12 20.0743L18.2857 23.7085C18.4599 23.8073 18.6569 23.8585 18.8571 23.8571C19.0573 23.8585 19.2544 23.8073 19.4286 23.7085C19.603 23.6079 19.7477 23.4629 19.848 23.2883C19.9484 23.1137 20.0008 22.9156 20 22.7143V4.42857C20 3.51926 19.6388 2.64719 18.9958 2.0042C18.3528 1.36122 17.4807 1 16.5714 1Z",
    fill: "#121314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilled);
export default __webpack_public_path__ + "static/media/bookmark-filled.bc927a5ded5af6f2ff496fd1d077eefa.svg";
export { ForwardRef as ReactComponent };